import TrimMileage from './TrimMileage';
import YearMakeModel from './YearMakeModel';

const VehicleYMMTM = () => (
  <div className="flex flex-col gap-4">
    <YearMakeModel />
    <TrimMileage />
  </div>
);

export default VehicleYMMTM;
